import { PlusOutlined, UserOutlined } from "@ant-design/icons";
import { useQuery } from "@tanstack/react-query";
import {
  Avatar,
  Button,
  Checkbox,
  Col,
  Flex,
  Form,
  Row,
  Spin,
  Switch,
} from "antd";
import React, { useState } from "react";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { getTeamMembersLocation } from "../../../network/teamMember";
import { queryKeys } from "../../../services/react-query/queryKeys";
import { TeamMemberType } from "../../../types/teamMember";
import Empty from "../../common/Empty";
import AddTeamMember from "../../teamMember/creatTeamMember/AddTeamMember";

interface InfoProps {
  onNextStep: () => void;
  onClose: () => void;
  serviceInfo: any;
  setServiceInfo: React.Dispatch<React.SetStateAction<{}>>;
}

function TeamMember({
  onNextStep,
  onClose,
  serviceInfo,
  setServiceInfo,
}: InfoProps) {
  console.log(serviceInfo?.team_members, "serviceInfo");
  const [selectedIds, setSelectedIds] = useState<any>(
    serviceInfo?.team_members?.length > 0
      ? serviceInfo?.team_members?.map((x: any) => x?.id || x)
      : []
  );
  const [isModalVisible, setIsModalVisible] = useState(false);

  const { locationId } = useSelector(
    (state: { calendar: { locationId: number } }) => state.calendar
  );

  const [form] = Form.useForm();

  const onChange = (checkedValues: any) => {
    setSelectedIds(checkedValues);
    setServiceInfo({
      ...serviceInfo,
      team_members: checkedValues,
    });
  };

  const { data: listTeamMember, isFetching } = useQuery(
    [queryKeys?.listTeamMember, locationId],
    () => getTeamMembersLocation(locationId)
  );

  const handleCheckAll = (e: any) => {
    if (e?.target?.checked) {
      const allIds = listTeamMember?.data.map(
        (item: TeamMemberType) => item.id
      );
      setSelectedIds(allIds);
      setServiceInfo({
        ...serviceInfo,
        team_members: allIds,
      });
    } else {
      setSelectedIds([]);
      setServiceInfo({
        ...serviceInfo,
        team_members: [],
      });
    }
  };

  const closeModal = () => {
    setIsModalVisible(false);
  };

  const onFinish = (value: object) => {
    setServiceInfo({
      ...serviceInfo,
      team_members: selectedIds,
    });
    onNextStep();
  };
  const intl = useIntl();

  return (
    <Form
      layout="vertical"
      onFinish={onFinish}
      initialValues={{
        enable_team_member_commission:
          serviceInfo?.enable_team_member_commission || false,
        // teamMember_id: serviceInfo?.team_members || [],
      }}
      form={form}
      onValuesChange={(changedValues: any, values: any) => {
        setServiceInfo({
          ...serviceInfo,
          ...changedValues,
          // name: values?.name,
        });
      }}
      className=""
    >
      <Spin spinning={isFetching} className="">
        <Row className="justify-center min-h-[60vh] w-full">
          <div className="">
            <div className="my-2 text-center">
              <Button
                onClick={() => setIsModalVisible(true)}
                className="border-none bg-[#EEF0FF] shadow-none outline-none text-[#75757E]"
                icon={<PlusOutlined />}
              >
                {intl.formatMessage({
                  id: "add_team_member",
                })}
              </Button>
            </div>
            {listTeamMember?.data?.length > 0 ? (
              <div className="w-full mt-4">
                <Checkbox.Group
                  value={selectedIds}
                  onChange={onChange}
                  // className="flex gap-4 flex-wrap"
                  className="grid grid-cols-3 gap-4"
                >
                  {/* <Form.Item name="teamMember_id" className="w-full"> */}
                  {listTeamMember?.data.map((item: TeamMemberType) => (
                    <Checkbox
                      value={item.id}
                      className="mb-3"
                      key={item.id}
                      checked={selectedIds?.includes(item?.id)}
                    >
                      <Flex className="gap-2">
                        <div>
                          <Avatar
                            icon={<UserOutlined />}
                            style={{ height: "48px", width: "48px" }}
                            className="bg-gray w-[15px] h-[10px]"
                            src={item?.media}
                            alt="Ellipse"
                          />
                        </div>
                        <div className="mt-3 mr-5">
                          <label
                            htmlFor="candidates"
                            className="font-medium text-gray-900 whitespace-nowrap"
                          >
                            {item?.name}
                          </label>
                        </div>
                      </Flex>
                    </Checkbox>
                  ))}
                  {/* </Form.Item> */}
                </Checkbox.Group>
                <div className="text-center my-2">
                  <Checkbox
                    value="checkAll"
                    className="mb-5"
                    onChange={handleCheckAll}
                    checked={
                      selectedIds?.length === listTeamMember?.data?.length
                    }
                  >
                    {intl.formatMessage({ id: "select_all_label" })}
                  </Checkbox>
                </div>
              </div>
            ) : !isFetching && listTeamMember?.data ? (
              <Empty
                title="لا يوجد اعضاء في فريقك حتى الآن"
                subTitle="لا يمكنك الاستمرار بدون اضافة عضو الى فريق عملك "
                classes="h-auto border-0 "
              />
            ) : null}
          </div>
        </Row>
      </Spin>
      <div className="mt-10 flex justify-between">
        <Col className="gutter-row">
          <label className="w-full mt-3 text-base ">
            {intl.formatMessage({ id: "commission_feature_label" })}
          </label>
        </Col>
        <Col className="gutter-row">
          <Form.Item
            valuePropName="checked"
            name="enable_team_member_commission"
          >
            <Switch />
          </Form.Item>
        </Col>
      </div>
      {isModalVisible && (
        <AddTeamMember
          visible={true}
          onClose={closeModal}
          showMinForm
          config={{
            locationId: locationId,
          }}
        />
      )}
      <Flex gap="middle" align="center" justify="center" className="">
        <Button
          type="primary"
          block
          htmlType="submit"
          disabled={selectedIds?.length === 0}
        >
          {intl.formatMessage({ id: "continue_button" })}
        </Button>
        <Button
          type="primary"
          onClick={onClose}
          className="btn-primary-light"
          block
          htmlType="button"
        >
          {intl.formatMessage({ id: "cancel_button" })}
        </Button>
      </Flex>
    </Form>
  );
}

export default TeamMember;
